/**
 * Backend buildBlobName() stores files as: `${uuidv4()}_${safeName}`
 * Strip only the UUID v4 prefix — not a generic underscore split — so filenames
 * that contain underscores stay intact.
 */
const BLOB_UUID_PREFIX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}_/i;

export function stripBlobUuidPrefix(blobName) {
  if (!blobName) return blobName;
  return blobName.replace(BLOB_UUID_PREFIX, "");
}

export function getBlobNameFromUrl(url) {
  if (!url || typeof url !== "string") return "";

  try {
    const pathname = url.split("?")[0];
    const encodedName = pathname.split("/").pop() || "";
    return decodeURIComponent(encodedName);
  } catch {
    return url.split("/").pop()?.split("?")[0] || "";
  }
}

/**
 * Resolves a user-friendly filename for project uploads.
 * Accepts File objects, API objects ({ originalName, file_path }), or blob URLs.
 */
export function getDisplayFileName(fileOrUrl) {
  if (!fileOrUrl) return "";

  if (typeof File !== "undefined" && fileOrUrl instanceof File) {
    return fileOrUrl.name;
  }

  if (typeof fileOrUrl === "object") {
    if (fileOrUrl.originalName) return fileOrUrl.originalName;
    if (fileOrUrl.file_name) return fileOrUrl.file_name;

    const url = fileOrUrl.file_path || fileOrUrl.url || fileOrUrl.filePath;
    if (url) {
      return stripBlobUuidPrefix(getBlobNameFromUrl(url));
    }

    if (fileOrUrl.name) return fileOrUrl.name;
    return "Unknown File";
  }

  if (typeof fileOrUrl === "string") {
    if (fileOrUrl.startsWith("http")) {
      return stripBlobUuidPrefix(getBlobNameFromUrl(fileOrUrl));
    }
    return stripBlobUuidPrefix(fileOrUrl);
  }

  return "Unknown File";
}
